import { createContext, useState, useCallback } from "react";

import Modal from "../components/Common/Modal";

const initialModalState = {
  show: false,
  modalResponse: "",
  modalResponseData: {},
  modalData: { type: "", data: {}, className: "" }
};

const ModalContext = createContext({
  ...initialModalState,
  openModalHandler: () => {},
  clearModalHandler: () => {},
  closeModalHandler: () => {}
});

export default ModalContext;

export function ModalContextProvider({ children }) {
  const [modalState, setModalState] = useState(initialModalState);

  const clearModalHandler = useCallback(() => {
    setModalState((state) => ({
      ...state,
      modalResponse: "",
      modalResponseData: {}
    }));
  }, []);

  const openModalHandler = useCallback(({ data, type, className }) => {
    setModalState((state) => ({
      ...state,
      show: true,
      modalData: { data, type, className }
    }));
  }, []);

  const closeModalHandler = useCallback((modalType, modalData) => {
    setModalState((state) => ({
      ...state,
      show: false,
      modalResponse: modalType,
      modalResponseData: modalData,
      modalData: initialModalState.modalData
    }));
  }, []);

  const modalContext = {
    ...modalState,
    openModalHandler,
    clearModalHandler,
    closeModalHandler
  };

  return (
    <ModalContext.Provider value={modalContext}>
      {children}
      <Modal
        show={modalState.show}
        modalData={modalState.modalData}
        closeModal={closeModalHandler}
        clearModal={clearModalHandler}
      />
    </ModalContext.Provider>
  );
}
